import { Button, IconButton, TextField, Typography } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { useSnackbar } from "notistack";
import React from "react";
import CopyToClipboard from "../CopyToClipboard";

interface Props {
  open: boolean;
  handleClose: () => any;
  handleSubmit: (username: string) => Promise<any>;
}

const CreateUserDialog: React.FC<Props> = ({
  open,
  handleClose,
  handleSubmit,
}) => {
  const [username, setUsername] = React.useState<string>("");
  const [loading, setLoading] = React.useState<boolean>(false);
  const [success, setSuccess] = React.useState<{
    Username: string;
    TemporaryPassword: string;
  }>();
  const { enqueueSnackbar } = useSnackbar();

  const _handleClose = () => {
    setUsername("");
    setSuccess(undefined);
    handleClose();
  };

  const _handleSubmit = () => {
    setLoading(true);
    handleSubmit(username)
      .then(({ Username, TemporaryPassword }) => {
        enqueueSnackbar("Benutzer wurde erstellt", {
          variant: "success",
        });
        setSuccess({ Username, TemporaryPassword });
      })
      .catch((error) => {
        console.log(error);
        enqueueSnackbar("Benutzer konnte nicht erstellt werden", {
          variant: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="create-user-dialog-title"
    >
      <DialogTitle id="create-user-dialog-title">
        Benutzer hinzufügen
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {!!success
            ? `Passwort für ${success.Username}`
            : "Benutzernamen für den neuen Benutzer eingeben"}
        </DialogContentText>
        {!!success ? (
          <>
            <Typography variant="button">
              Passwort: {success.TemporaryPassword}
            </Typography>
            <CopyToClipboard>
              {({ copy }) => (
                <IconButton onClick={() => copy(success.TemporaryPassword)}>
                  <FileCopyIcon />
                </IconButton>
              )}
            </CopyToClipboard>
          </>
        ) : (
          <TextField
            autoFocus
            onChange={(event) => setUsername(event.target.value)}
            margin="dense"
            value={username}
            id="username"
            label="Benutzername"
            fullWidth
          />
        )}
      </DialogContent>
      <DialogActions>
        {!!success ? (
          <Button onClick={_handleClose} color="primary">
            Schließen
          </Button>
        ) : (
          <>
            <Button onClick={_handleClose} color="primary">
              Abbrechen
            </Button>
            <Button disabled={loading} onClick={_handleSubmit} color="primary">
              Hinzufügen
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default CreateUserDialog;
